





























    import Header from '../components/MarketplaceHeader.vue'
    import MarketplaceProduct from '../components/MarketplaceProduct/MarketplaceProduct.vue'
    import FreshShops from '../components/FreshShops.vue'
    import {
        Component,
        Vue
    } from "vue-property-decorator";
import HomeBanner from '../components/MarketplaceBanner/HomeBanner.vue';
import MarketplaceShopProfileProducts from '../components/MarketplaceShopProfile/MarketplaceShopProfileProducts.vue';
import MarketplaceShopProfileBanners from '../components/MarketplaceShopProfile/MarketplaceShopProfileBanners.vue';
import { Instance, TyMarketplace } from '@/classes/TayehApi';

    @Component({
        components: {
            Header,
            MarketplaceProduct,
            FreshShops,
            HomeBanner,
            MarketplaceShopProfileProducts,
            MarketplaceShopProfileBanners
        }
    })
    export default class MarketplaceShopProfile extends Vue {
        private search_phrase = '';
        private selected_category: string = null;
        async getCategories (search: string) {
            const res = await TyMarketplace.getTyMarketplaceShopCategories(this.$route.params.shop_username, {search})
            return res.data.map((category: any) => ({
                label: category.name,
                value: category.id
            }))
        }
    }
